const menu = {
    label: 'Emails',
    icon: 'pi pi-fw pi-comments',
    to: '/gestaoemails/emails',
    rules: ['EMAIL-DETALHAR-00'],
};

export default menu;
